import React from "react";
import LoanApplication from "../../../models/loan/loanApplication";
import Table from "react-bootstrap/esm/Table";
import "./LoanApplicationInformationSection.css"
import loanApplicationUtility from "../../../utilities/LoanApplicationUtility";
import { LoanType } from "shared/Enums";

interface LoanApplicationInformationSectionProps {
  loanDetails: LoanApplication;
  summary?: boolean;
}

const closedStatuses = loanApplicationUtility.GetClosedLoanStatuses();

export default class LoanApplicationInformationSection extends React.Component<LoanApplicationInformationSectionProps> {
  getBusinessSectorText(loanType: LoanType): string {
    if (loanType === LoanType.GapFinancing) {
      return 'Business';
    } else {
      return 'Farm/Business';
    }
  }

  getOffBusinessSectorText(loanType: LoanType): string {
    if (loanType === LoanType.GapFinancing) {
      return 'Outside';
    } else {
      return 'Off-Farm/Outside';
    }
  }

  getPrimaryAgProductText(): string {
    if (this.props.loanDetails.primaryAgProduct != undefined) {
      let selectedAgProduct = loanApplicationUtility.GetPrimaryAgProductOptions().find(apo => apo.value === this.props.loanDetails.primaryAgProduct);
      return `${selectedAgProduct?.value} - ${selectedAgProduct?.label}`;
    } else {
      return '*NOT A FARMER*';
    }
  }

  render() {
    return (
      <>
        <div>
          <h3>Application Information</h3>

          <Table bordered striped={false} size="sm">
            <tbody>
              <tr>
                <td width="250px" className="app-info"><strong>Reference Number</strong></td>
                <td className="app-info">{this.props.loanDetails.id != undefined ? loanApplicationUtility.BuildDisplayId(this.props.loanDetails.id) : '--'}</td>
              </tr>
              <tr>
                <td width="250px" className="app-info"><strong>Date Submitted</strong></td>
                <td className="app-info">{loanApplicationUtility.GetDateMonthNameFullYear(this.props.loanDetails.dateSubmitted ?? new Date())}</td>
              </tr>
              {!this.props.summary &&
                <>
                  <tr>
                    <td width="250px" className="app-info"><strong>Status</strong></td>
                    <td className="app-info">{loanApplicationUtility.GetLoanStatusText(this.props.loanDetails.status)}</td>
                  </tr>
                </>
              }
              {this.props.loanDetails.loanAmount > 0 &&
                <tr>
                  <td width="250px" className="app-info"><strong>{this.props.loanDetails.loanType === LoanType.EquipmentAuctionPurchase && !closedStatuses.includes(this.props.loanDetails.status) ? 'Pre-Qualified Amount' : 'Loan Amount'}</strong></td>
                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.loanAmount)}
                    {this.props.loanDetails.originalLoanAmount != undefined &&
                      <>
                        <span style={{ fontStyle: 'italic', fontWeight: 'bolder', color: 'green' }}>
                          {` (Original Request: ${loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.originalLoanAmount)})`}
                        </span>
                      </>
                    }
                  </td>
                </tr>
              }
              <tr>
                <td width="250px" className="app-info"><strong>Loan Purpose</strong></td>
                <td className="app-info">{loanApplicationUtility.GetLoanTypeText(this.props.loanDetails.loanType)}</td>
              </tr>
              {!this.props.summary &&
                <>
                  <tr>
                    <td width="250px" className="app-info"><strong>Submitted By</strong></td>
                    <td className="app-info">{loanApplicationUtility.JoinApplicantNames(this.props.loanDetails.applicant, this.props.loanDetails.jointApplicant)}</td>
                  </tr>
                  <tr>
                    <td width="250px" className="app-info"><strong>Email Address</strong></td>
                    <td className="app-info">{this.props.loanDetails.customerAccount.email}</td>
                  </tr>
                  <tr>
                    <td width="250px" className="app-info"><strong>Phone Number</strong></td>
                    <td className="app-info">{loanApplicationUtility.FormatPhoneNumber(this.props.loanDetails.customerAccount.phoneNumber)}</td>
                  </tr>
                  <tr>
                    <td width="250px" className="app-info"><strong>{`${this.getBusinessSectorText(this.props.loanDetails.loanType)} Experience`}</strong></td>
                    <td className="app-info">{loanApplicationUtility.GetYearsExperience(this.props.loanDetails.customerAccount.farmingStartYear)}</td>
                  </tr>
                </>
              }
              <tr>
                <td width="250px" className="app-info"><strong>{`Current ${this.getBusinessSectorText(this.props.loanDetails.loanType)} Revenues`}</strong></td>
                <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.projectedGrossRevenues?.farmRevenues)}</td>
              </tr>
              <tr>
                <td width="250px" className="app-info"><strong>{`Current ${this.getOffBusinessSectorText(this.props.loanDetails.loanType)} Revenues`}</strong></td>
                <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.projectedGrossRevenues?.offFarmRevenues)}</td>
              </tr>
              <tr>
                <td width="250px" className="app-info"><strong>{`Prior Year ${this.getBusinessSectorText(this.props.loanDetails.loanType)} Revenues`}</strong></td>
                <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.priorGrossRevenues?.farmRevenues)}</td>
              </tr>
              <tr>
                <td width="250px" className="app-info"><strong>{`Prior Year ${this.getOffBusinessSectorText(this.props.loanDetails.loanType)} Revenues`}</strong></td>
                <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.priorGrossRevenues?.offFarmRevenues)}</td>
              </tr>
              <tr>
                <td width="250px" className="app-info"><strong>{`Primary Ag Product`}</strong></td>
                <td className="app-info">{this.getPrimaryAgProductText()}</td>
              </tr>
            </tbody>
          </Table>
        </div>

      </>
    );
  }
}